import { render, staticRenderFns } from "./AppPager.vue?vue&type=template&id=6fb20a25&"
import script from "./AppPager.vue?vue&type=script&lang=js&"
export * from "./AppPager.vue?vue&type=script&lang=js&"
import style0 from "./AppPager.vue?vue&type=style&index=0&lang=module.scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports